import { Button, Typography, Paper, Grid, Container } from '@mui/material'
import I18n from 'i18n-js'
import { makeStyles } from 'tss-react/mui'

import { connect, selectors } from '@src/stores'

import AuthCardHeader from '../AuthCardHeader'
import AuthPageLayout from '../AuthPageLayout'

import LoginForm from './LoginForm'

const useStyles = makeStyles()((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
  button: {
    'backgroundColor': theme.palette.pbxxCyan.main,
    '&:hover': {
      backgroundColor: theme.palette.pbxxCyan.dark,
    },
  },
  paper: {
    padding: theme.spacing(2),
    height: '100%',
  },
  wrapper: {
    padding: theme.spacing(4),
  },
}))
const LoginView: React.FC<React.PropsWithChildren> = () => {
  const { classes } = useStyles()

  return (
    <AuthPageLayout>
      <Container fixed maxWidth="xl">
        <Grid
          container
          spacing={6}
          justifyContent="center"
          alignContent="center"
          className={classes.wrapper}
        >
          <Grid item xs={12} md={8} lg={6}>
            <Paper className={classes.paper}>
              <LoginForm />
            </Paper>
          </Grid>
          <Grid item xs={12} md={4} lg={6}>
            <Paper className={classes.paper}>
              <AuthCardHeader
                hideHelp
                header={I18n.t('auth.newToPromoboxxQuestionMark')}
              />
              <div className={classes.container}>
                <Typography align="center" variant={'h6'} paragraph>
                  {I18n.t('auth.youNeedToCreateAPromoboxxAccount')}
                </Typography>

                <Button
                  color="primary"
                  variant="contained"
                  size="large"
                  href="/request-access"
                  className={classes.button}
                >
                  {I18n.t('auth.requestAccess')}
                </Button>
              </div>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </AuthPageLayout>
  )
}

LoginView.propTypes = {}

export default connect((state) => ({
  ...selectors.auth.selectIsAuthenticated(state),
}))(LoginView)
